import { InvestigacionesService } from "../../../servicesBackend/investigaciones.service";
import {
    Actualizador,
    BasicoActualizador,
    DatosCuotasActualizador,
    EnvioActualizador,
    FunnelActualizador,
    GrupoActualizador,
    GrupoCuotaActualizador,
    MarcadorActualizador
} from "./actualizador";
import { GruposFiltrosService } from "../../../../layout/investigaciones/gruposFiltros.service";
import { RespuestasService } from "../../../../layout/investigaciones/ver-respuestas/respuestas.service";
import { GrupoFiltroActualizador } from "./actualizador/GrupoFiltroActualizador";
import { CuestionarioActualizador } from "./actualizador/CuestionarioActualizador";
import { InvestigacionDTO } from "@DTOS";

export const obtenerActualizadores:
    (investigacionesService: InvestigacionesService, gruposFiltrosService: GruposFiltrosService,
        respuestasService: RespuestasService) => Actualizador<InvestigacionDTO>[] =
    (investigacionesService, gruposFiltrosService, respuestasService) => [
        new EnvioActualizador(investigacionesService) as unknown as Actualizador<InvestigacionDTO>,
        new GrupoActualizador(investigacionesService),
        new BasicoActualizador(investigacionesService),
        new GrupoCuotaActualizador(gruposFiltrosService),
        new DatosCuotasActualizador(investigacionesService),
        new FunnelActualizador(investigacionesService),
        new MarcadorActualizador(investigacionesService, respuestasService),
        new GrupoFiltroActualizador(gruposFiltrosService),
        new CuestionarioActualizador()
    ];
